import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Message } from '../models/message';
import { FormGroup, FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
import { switchMap } from 'rxjs/operators';
import { DialogService, DialogRef } from '@progress/kendo-angular-dialog';
import { MessageStoreScope } from '../models/message-store';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {

  constructor(private dialogService: DialogService) { }

  ngOnInit(): void {
  }

  private message: Message;
  public active = false;
  public editForm: FormGroup;
  public gridItems: Observable<GridDataResult>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10,
  };
  
  @Input() public scope: MessageStoreScope;
  @Input() public set model(value: Message){
    this.editForm = this.createFormGroup();
    this.editForm.reset(value);
    this.active = value !== undefined;
    this.message = value;

    if (this.active) {
      this.gridItems = of(value.UserProperties)
      .pipe(
        switchMap((data) => {
          const gridResult: GridDataResult = {
            data: [...data],
            total: data.length,
          };
          return of(gridResult);
        })
      );     
    }
  }
  public get model(){
    return this.message;
  }

  @Output() cancel: EventEmitter<any> = new EventEmitter();  
  @Output() delete: EventEmitter<Message> = new EventEmitter();
  @Output() resubmit: EventEmitter<Message> = new EventEmitter();

  public onCancel(e): void {
    e.preventDefault();
    this.closeForm();
  }

  public onDelete(e): void {
    const deleteAction = { text: "Delete", primary: true };
    const cancelAction = { text: "Cancel" };
    const dialog: DialogRef = this.dialogService.open({
      title: "Please confirm",
      content: "Deleting this message cannot be undone.",
      actions: [cancelAction, deleteAction],
    });

    dialog.result.subscribe((result) => {
      if (result === deleteAction) {
        e.preventDefault();
        let msg: Message = this.editForm.value;
        this.active = false;
        this.delete.emit(msg);
      }
    }); 
  }

  public onResubmit(e): void {
    const resubmitAction = { text: "Resubmit", primary: true };
    const cancelAction = { text: "Cancel" };
    const dialog: DialogRef = this.dialogService.open({
      title: "Please confirm",
      content: "Resubmitting this message will make it process again.",
      actions: [cancelAction, resubmitAction],
    });

    dialog.result.subscribe((result) => {
      if (result === resubmitAction) {
        e.preventDefault();
        let msg: Message = this.editForm.value;
        this.active = false;
        this.resubmit.emit(msg);
      }
    }); 
  }

  public closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }

  private createFormGroup() : FormGroup {
    let isDisabled = this.scope == MessageStoreScope.Queue || this.scope == MessageStoreScope.Subscription;
    return new FormGroup({
      Id: new FormControl(),
      Body: new FormControl({value: '', disabled: isDisabled})
    });
  }

}
